import { WorkflowDefinition } from '@amzn/snow-nxt-workflow-service-typescript-client';
import { SUB_WORKFLOW_TASK_TYPE } from 'src/constants/CommonConstants';
import { TaskTypeListItem } from './taskTypeListStore.interface';

/**
 * Maps ListSupportedTasks.supportedSubWorkflows onto the palette item shape.
 */
export function convertSubWorkflowsIntoTaskSchema(
	supportedSubWorkflows: WorkflowDefinition[] | undefined,
	parentWorkflowId?: string
): TaskTypeListItem[] {
	return (supportedSubWorkflows ?? [])
		.filter(
			(subWorkflow): subWorkflow is WorkflowDefinition & { workflowId: string } =>
				!!subWorkflow.workflowId && subWorkflow.workflowId !== parentWorkflowId
		)
		.map((subWorkflow) => ({
			taskId: subWorkflow.workflowId,
			taskName: subWorkflow.workflowDefinitionName ?? '',
			description: subWorkflow.description ?? '',
			entityTypeSupported: subWorkflow.entityType,
			applicationName: SUB_WORKFLOW_TASK_TYPE,
			taskInputs: [],
			taskOutputs: [],
			isSubWorkflow: true,
			childWorkflowId: subWorkflow.workflowId,
		}));
}

export function convertOperationsIntoTaskSchema(activeOperations) {
	const convertedOperations: TaskTypeListItem[] = [];

	activeOperations.forEach((activeOperation) => {
		const taskTypeListItem: TaskTypeListItem = {
			taskId: activeOperation.operationId,
			taskName: activeOperation.operationName,
			description: activeOperation.description,
			taskInputs: activeOperation.taskInputs,
			taskOutputs: activeOperation.taskOutputs,
			applicationId: activeOperation.applicationId,
			applicationName: activeOperation.applicationName,
			requestBody: activeOperation.requestBody,
			response: activeOperation.response,
			version: activeOperation.version,
			cti: activeOperation.cti,
			operation: true,
			operationId: activeOperation.operationId,
		};

		convertedOperations.push(taskTypeListItem);
	});

	return convertedOperations;
}
